import type { FC } from 'react';
import { memo } from 'react';
import './index.scss';

const LandingFooter: FC = () => (
  <div className='landing-footer'>
    <div className='landing-footer__content'>
      <div className='landing-footer__copyright'>
        © 2005-{new Date().getFullYear()} Деликатеска.ру — интернет-магазин
        продуктов. Все права защищены
      </div>
      <div className='landing-footer__links'>
        <a
          href='/license-agreement'
          className='landing-footer__link'
          target='_blank'
          rel='noreferrer'
        >
          Пользовательское соглашение
        </a>
        <a
          href='/confidential'
          className='landing-footer__link'
          target='_blank'
          rel='noreferrer'
        >
          Политика конфиденциальности
        </a>
      </div>
    </div>
  </div>
);

export default memo(LandingFooter);
